import React, { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { Menu, X, Phone } from 'lucide-react';
import { useI18n } from '../i18n';
import { Button } from './ui/button';
import { company } from '../mock';

const Navbar = () => {
  const { t, lang, setLang } = useI18n();
  const [open, setOpen] = useState(false);

  const links = [
    { to: '/services', label: t('nav.services') },
    { to: '/fleet', label: t('nav.fleet') },
    { to: '/excursions', label: t('nav.excursions') },
    { to: '/cities', label: t('nav.cities') },
    { to: '/disneyland', label: t('nav.disneyland') },
    { to: '/business', label: t('nav.business') },
    { to: '/about', label: t('nav.about') },
    { to: '/contact', label: t('nav.contact') }
  ];

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-black/95 backdrop-blur-md border-b border-white/10">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10 h-[72px] flex items-center justify-between">
        <Link to="/" className="flex items-center gap-3 text-white group">
          <div className="ha-logo-wrap h-12 w-12 rounded-full overflow-hidden bg-black ring-1 ring-white/20 group-hover:ring-white/60 transition">
            <img
              src="https://customer-assets.emergentagent.com/job_ha-transport/artifacts/7sk20ayj_IMG_7956.png"
              alt="Ha Transport"
              className="ha-logo h-full w-full object-cover"
            />
          </div>
          <div className="hidden sm:flex flex-col leading-tight">
            <span className="font-serif text-xl tracking-wide">Ha Transport</span>
            <span className="text-[9px] tracking-[0.3em] uppercase text-white/60">Roissy CDG</span>
          </div>
        </Link>

        <nav className="hidden lg:flex items-center gap-8">
          {links.map(l => (
            <NavLink
              key={l.to}
              to={l.to}
              className={({ isActive }) =>
                `text-sm tracking-wide transition-colors ${isActive ? 'text-white' : 'text-white/70 hover:text-white'}`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a href={`tel:${company.phone.replace(/\s/g, '')}`} className="hidden md:flex items-center gap-2 text-sm text-white/80 hover:text-white">
            <Phone className="w-4 h-4" />
            <span className="tracking-wide">{company.phone}</span>
          </a>
          <div className="hidden md:flex items-center text-xs text-white/60 border border-white/15 rounded-full overflow-hidden">
            <button onClick={() => setLang('fr')} className={`px-3 py-1 ${lang === 'fr' ? 'bg-white text-black' : ''}`}>FR</button>
            <button onClick={() => setLang('en')} className={`px-3 py-1 ${lang === 'en' ? 'bg-white text-black' : ''}`}>EN</button>
          </div>
          <Link to="/contact" className="hidden md:inline-flex">
            <Button className="bg-white text-black hover:bg-white/90 rounded-none px-5 h-9 text-sm tracking-wide">{t('nav.book')}</Button>
          </Link>
          <button className="lg:hidden text-white" onClick={() => setOpen(!open)}>
            {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
          </button>
        </div>
      </div>
      {open && (
        <div className="lg:hidden bg-black border-t border-white/10">
          <div className="px-6 py-6 flex flex-col gap-4">
            {links.map(l => (
              <NavLink key={l.to} to={l.to} onClick={() => setOpen(false)} className="text-white/80 text-base">
                {l.label}
              </NavLink>
            ))}
            <div className="flex items-center gap-2 pt-2">
              <button onClick={() => setLang('fr')} className={`px-3 py-1 text-xs border ${lang === 'fr' ? 'bg-white text-black' : 'border-white/30 text-white'}`}>FR</button>
              <button onClick={() => setLang('en')} className={`px-3 py-1 text-xs border ${lang === 'en' ? 'bg-white text-black' : 'border-white/30 text-white'}`}>EN</button>
            </div>
            <a href={`tel:${company.phone.replace(/\s/g, '')}`} className="text-white/70 text-sm flex items-center gap-2"><Phone className="w-4 h-4" /> {company.phone}</a>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
